import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { oidcConfig } from "./auth/oidcConfig";
import { SessionProvider } from "./auth/session/SessionProvider";
import { TokenSync } from "./auth/TokenSync";
import { installDomMutationGuard } from "./lib/domMutationGuard";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./i18n";
import "./index.css";

// Before the first render, so React never gets a chance to commit against an
// unguarded DOM: turns an extension-mangled node into a console warning rather
// than a page-killing NotFoundError.
installDomMutationGuard();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* AuthProvider stays mounted in every mode: it still owns the redirect
        flow, which "Continue with Google" — and all of Keycloak-backed local
        dev — needs. SessionProvider merges it with the native sign-in. */}
    <AuthProvider {...oidcConfig}>
      <ThemeProvider>
        {/* SessionProvider sits INSIDE the router: it navigates to /signin when
            an anonymous visitor needs to sign in, so it needs router context.
            TokenSync moved in with it (it reads the session) — it mirrors the
            API token into a module-scoped store and listens for "auth-expired"
            so the API client can trigger a refresh / re-login from outside
            React. */}
        <BrowserRouter>
          <SessionProvider>
            <TokenSync />
            {/* The AuthGate lives INSIDE App: the /@handle agent-card route and
                the public booking pages must render for anonymous visitors, so
                App decides per-path whether to gate. */}
            <App />
          </SessionProvider>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
);
